export default function getResource(label, vars = []) {
    const resources = {
        termsPrefix: 'By clicking "Sign In", you (1) agree to the current version of Sephora’s ',
        termsAnd: ', and (2) have read Sephora\'s ',
        privacyPolicy: 'Privacy Policy',
        termsOfUse: 'TERMS OF USE',
        oauth2TermsPrefix: 'By clicking \'Sign In and Allow Access,\' you agree to Sephora\'s ',
        oauth2TermsMiddle: ' and Sephora\'s ',
        oauth2ChatGPTPrivacy: ', and ChatGPT\'s ',
        oauth2AuthorizeSuffix: ', and authorize ChatGPT to access your Beauty Insider account, personal information, and shopping cart (including updates). Review or remove access anytime in your ChatGPT settings by disconnecting the Sephora app.'
    };

    return resources[label];
}
